var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrograms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99999C20 8.64499 19.405 7.36665 18.3958 6.56332C18.5125 5.21165 18.0292 3.88749 17.0708 2.92832C16.1125 1.97082 14.7917 1.48582 13.5067 1.63249C11.8283 -0.497514 8.2025 -0.537514 6.56334 1.60332C3.86917 1.28332 1.27834 3.81999 1.63334 6.49332C-0.496665 8.17165 -0.537498 11.7975 1.60417 13.4375C1.4875 14.7892 1.97084 16.1133 2.92917 17.0725C3.8875 18.03 5.21 18.515 6.49334 18.3683C8.17167 20.4983 11.7975 20.5383 13.4367 18.3975C14.7867 18.5133 16.1117 18.0317 17.0708 17.0725C18.0283 16.1142 18.5117 14.7892 18.3667 13.5083C19.405 12.635 20 11.3567 20 10.0017V9.99999ZM6.66667 7.49999C6.67167 6.40999 8.32834 6.40999 8.33334 7.49999C8.32834 8.58999 6.67167 8.58999 6.66667 7.49999ZM9.02667 12.9625C8.77 13.3483 8.24917 13.4467 7.87084 13.1933C7.4875 12.9383 7.38417 12.4208 7.64 12.0375L10.9733 7.03749C11.2283 6.65499 11.745 6.54999 12.1292 6.80665C12.5125 7.06165 12.6158 7.57915 12.36 7.96249L9.02667 12.9625ZM12.5 13.3333C11.41 13.3283 11.41 11.6717 12.5 11.6667C13.59 11.6717 13.59 13.3283 12.5 13.3333Z",
    fill: "url(#paint0_linear_188_237)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_237",
    x1: 10.0084,
    y1: 0.0162354,
    x2: 10.0084,
    y2: 19.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrograms);
export default __webpack_public_path__ + "static/media/programs.a4d27efb251722b1495e2ce0a2bde467.svg";
export { ForwardRef as ReactComponent };